// @param concat [Boolean]
/**
 * 深 merge, 如 deepMerge({a: [{ b: 1 }] } , {a: [{b: 2}], c: 3}) 结果为{a: [{b: 2}], c: 3}
 * @concat {[Boolean]} 如果是 true，数组会合并，上述结果为{a: [{b: 1}, {b: 2}], c: 3}
 */
import { message } from 'antd';

export function getArrayRandom(arr, num) {
  const tempArray = [];

  // eslint-disable-next-line
  for (let index in arr) {
    tempArray.push(arr[index]);
  }

  const returnArray = [];
  for (let i = 0; i < num; i += 1) {
    if (tempArray.length > 0) {
      const arrIndex = Math.floor(Math.random() * tempArray.length);
      returnArray[i] = tempArray[arrIndex];
      tempArray.splice(arrIndex, 1);
    } else {
      break;
    }
  }
  return returnArray;
}

export const hasScrollbar = () =>
  document.body.scrollHeight >
  (window.innerHeight || document.documentElement.clientHeight);

export const throttle = (fn, wait = 100) => {
  let time = Date.now();
  return v => {
    if (time + wait - Date.now() < 0) {
      fn(v);
      time = Date.now();
    }
  };
};

/**
 * @param {Array} nodes 树节点
 * @param {String} key
 * @desc 递归查找树的福节点或者节点
 * @example
 * nodes: [
 *  key: '0-0'
 *  title: '0-0'
 *  chidren: [
 *    key: '0-0-1'
 *    title: '0-0-1',
 *    chidren: [...]
 *  ]
 * ]
 */

export function createTree(data) {
  data.forEach(item => {
    delete item.children; // eslint-disable-line
  });
  const map = {};
  data.forEach(item => {
    map[item.id] = item;
  });
  const val = [];
  data.forEach(item => {
    const parent = map[item.parent];
    if (parent) {
      (parent.children || (parent.children = [])).push(item);
    } else {
      val.push(item);
    }
  });
  return val;
}

export function findTreeNode(nodes, key) {
  let node = null;
  let parentNode = null;

  function fn(tree, nodeId) {
    for (let i = 0; i < tree.length; i += 1) {
      if (node) {
        break;
      }

      const obj = tree[i];
      if (!obj || !obj.id) {
        continue; // eslint-disable-line
      }

      if (obj.id === nodeId) {
        node = obj;
        break;
      } else if (obj.children && obj.children.length) {
        parentNode = obj;
        fn(obj.children, nodeId);
      } else {
        continue; // eslint-disable-line
      }
    }

    if (!node) {
      parentNode = null;
    }
  }

  fn(nodes, key);

  return {
    parentNode,
    node,
  };
}

let timeout;
export function debounce(func, wait = 300) {
  // eslint-disable-next-line
  return function() {
    // eslint-disable-next-line
    let context = this;
    // eslint-disable-next-line
    let args = arguments;

    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}

// 后台错误提示
export function backendErrorTip(error) {
  if (!error) {
    return;
  }
  let tip;
  const cName = error.constructor.name;
  if (cName === 'String') {
    tip = error;
  } else if (cName === 'Array') {
    tip = error[0];
  } else if (cName === 'Object') {
    const oTip = Object.values(error)[0];
    tip = backendErrorTip(oTip);
  }
  if (tip) {
    message.warning(tip);
  }
}
